import React from 'react';

const Button = ({ type, text, onClick }) => {
  return (
    <button className={`btn thule-btn-${type} hide-fit-guide-modal mt-4 w-100 mb-5`} onClick={onClick}>
      {text}
    </button>
  );
};

export default Button;
